var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7517 30C32.4966 30 36 27.1984 36 22.9961C36 19.3774 33.2215 16.1089 28.8725 16.1089C26.5772 16.1089 23.9195 15.0584 23.9195 12.607C23.9195 9.33852 28.5101 4.08561 35.0336 1.40078L34.4295 0C26.8188 3.26848 20.2953 9.45525 20.2953 19.8444C20.2953 24.5136 22.1074 30 28.7517 30ZM8.45638 30C12.2013 30 15.7047 27.1984 15.7047 22.9961C15.7047 19.3774 12.9262 16.1089 8.57718 16.1089C6.28188 16.1089 3.62416 15.0584 3.62416 12.607C3.62416 9.33852 8.21476 4.08561 14.7383 1.40078L14.1342 0C6.52349 3.26848 0 9.45525 0 19.8444C0 24.5136 1.81208 30 8.45638 30Z",
    fill: "#8B1026"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.0e2c19f988e9c3d06942e02ff0c12387.svg";
export { ForwardRef as ReactComponent };